import { getLocaleFromBrowserLanguage } from 'grab-locale';
import { STORAGE_LOCALE } from 'constants/app-constants';
import { LOCALES } from 'constants/locales';

const getLocaleFallback = () => {
  const locale = window.localStorage.getItem(STORAGE_LOCALE);
  if (!locale) return '';
  return LOCALES.includes(locale) ? locale : 'en';
};

export const getLocale = () =>
  getLocaleFallback() ||
  getLocaleFromBrowserLanguage({
    defaultLocale: 'en',
    availableLocales: LOCALES,
    navigator: window.navigator,
  });

export default {};
